<template>
    <ReceiptLogUnitDetail
        v-if="loaded && receiptLogUnit"
        :receipt-log-unit="receiptLogUnit"
        @download="downloadFile"
        @requestDelivery="requestDelivery"
    />
    <Page404 v-else-if="loaded" message="That Receipt Log unit was not found" />
</template>
<script>
import { mapState, mapActions } from "vuex";
import Page404 from "src/components/NotFoundPage.vue";
import store from "./_store";
import ReceiptLogUnitDetail from "./_components/ReceiptLogUnitDetail.vue";
import { mutations } from "src/global-store.js";

export default {
    name: "ReceiptLogUnitDetailModule",
    components: {
        ReceiptLogUnitDetail,
        Page404,
    },
    data() {
        return {
            loaded: false,
        };
    },
    computed: {
        ...mapState("$_receiptLogUnit", {
            receiptLogUnit: (state) => state.selectedReceiptLogUnit,
        }),
    },
    beforeCreate() {
        this.$store.registerModule("$_receiptLogUnit", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_receiptLogUnit");
    },
    async created() {
        await this.fetchReceiptLogUnit({
            receiptLogId: this.$route.params.receiptId,
            unitId: this.$route.params.id,
        });
        mutations.setNavbarTitle(
            "Receipt Log " +
                this.receiptLogUnit?.receiptLogId +
                ", Unit ID #" +
                this.receiptLogUnit?.unitId,
            this.receiptLogUnit?.customer?.name,
        );
        this.loaded = true;
    },
    methods: {
        ...mapActions(["downloadFile"]),
        ...mapActions("$_receiptLogUnit", ["fetchReceiptLogUnit"]),
        ...mapActions("deliveryRequest", ["addToPendingReceiptLogs"]),
        requestDelivery() {
            this.addToPendingReceiptLogs({
                receiptLogs: [
                    {
                        ...this.receiptLogUnit.receiptLog,
                        units: [this.receiptLogUnit],
                    },
                ],
            });
        },
    },
};
</script>
